import { Button } from '@/components/ui/button';
import { WandSparkles } from 'lucide-react';

interface SurpriseMeButtonProps {
    onSurprise: () => void;
}

export function SurpriseMeButton({ onSurprise }: SurpriseMeButtonProps) {
  return (
    <Button
        type="button"
        variant="link"
        onClick={onSurprise}
        className="w-full"
    >
        <WandSparkles className="mr-2 h-4 w-4" />
        I'm feeling adventurous, surprise me!
    </Button>
  );
}
